import { ErrorMessage } from '@hookform/error-message';
import {
  Alert,
} from '@mui/material';
import React from 'react';

interface InputErrorMessagesProps {
  name: string,
  errors: object,
}

function InputErrorMessages(props:InputErrorMessagesProps) {
  const {
    name,
    errors,
  } = props;

  return(
    <ErrorMessage
      name={name}
      errors={errors}
      as={<Alert role="alert" severity="error" />}
    />
  );
}

export default InputErrorMessages;
